import React from 'react'
import PropTypes from 'prop-types'
import { DatePicker } from 'material-ui-pickers'
import { CalendarTodayOutlined, KeyboardArrowLeftOutlined, KeyboardArrowRightOutlined } from '@material-ui/icons'
import moment from 'moment'

// TODO: weekend work needed :) working for now in this separate component...
const debugLogOn = false
const debug = debugLogOn ? (...args) => console.log('[DEBUGLOG]', ...args) : () => undefined
// ----

const replaceCharAt = (str, index, char) => {
	if (!str || index < 0 || index >= str.length) {
		return str
	}
	const prefix = str.substring(0, index)
	const suffix = str.substring(index + 1)
	return `${prefix}${char}${suffix}`
}

const insertAt = (str, index, what) => {
	if (!str || index < 0 || index >= str.length) {
		return str
	}
	const prefix = str.substring(0, index)
	const suffix = str.substring(index)
	return `${prefix}${what}${suffix}`
}

const dateOfBirthPipe = (conformedValue, config) => {
	// if (!config.previousConformedValue && !config.rawValue) {
	// 	debug('bail out')
	// 	return conformedValue
	// }

	debug('conformedValue, config', conformedValue, config)

	let rawValue = config.rawValue

	// repair deletes
	if (config.previousConformedValue && rawValue.length < config.previousConformedValue.length) {
		let deletedSection = config.previousConformedValue.substr(config.currentCaretPosition, config.previousConformedValue.length - rawValue.length)
		deletedSection = deletedSection.replace(/\d/g, '_')
		rawValue = insertAt(rawValue, config.currentCaretPosition, deletedSection)
	} else if ((rawValue.match(/\//g) || []).length > 2) {
		// if the date separator was entered, just change it to something else so we can still split the date
		const lastEnteredIndex = config.currentCaretPosition - 1
		if (rawValue.charAt(lastEnteredIndex) === '/') {
			rawValue = replaceCharAt(rawValue, lastEnteredIndex, '-')
		}
	}

	let [dd, mm, yyyy] = rawValue.split('/')
	const indexesOfPipedChars = []
	let hasNewValue = false // TODO: probably don't need this now, if updating indexesOfPipedChars properly...
	debug('dd, mm, yyyy', dd, mm, yyyy)

	if (dd) {
		if (dd.match(/^[1-3][.:\W-/]|^[4-9]/)) {
			dd = `0${dd.charAt(0)}`
			indexesOfPipedChars.push(0)
			hasNewValue = true
		}
	}
	if (mm) {
		if (mm.match(/^(1[.:\W-/]|[2-9])/)) {
			mm = `0${mm.charAt(0)}`
			indexesOfPipedChars.push(3)
			hasNewValue = true
		}
	}
	if (yyyy) {
		if (yyyy.match(/^(0[0-9]|1[0-8])/)) {
			yyyy = `20${yyyy.substr(0, 2)}`
			indexesOfPipedChars.push(6)
			indexesOfPipedChars.push(7)
			hasNewValue = true
		} else if (yyyy.match(/^(2[1-9]|[3-9][0-9])/)) {
			yyyy = `19${yyyy.substr(0, 2)}`
			indexesOfPipedChars.push(6)
			indexesOfPipedChars.push(7)
			hasNewValue = true
		}
	}

	// TODO: how to proceed:
	//		format inserts
	//		split up fields
	//		do the logic checks
	//			passing on numbers from fields with too many chars

	// TODO: maybe we should be taking any characters added, and replacing any punctuation with /'s, then splitting the whole thing (handles pasting say 12-2000 into the months box, or 1-1-1990 into the start of the days box while it is filled.)

	// TODO: must prevent bad characters... how to stop validation if there is still mask chars? cant set actual value... can we?

	// TODO: make this a component, let the picker have it's two values, make the wrapping component  have a single value representing the date or the date entry (i.e. we don't want to use the moment date as the value like when we have the component juts in here)
	// XXXXXX NOPE need to write a validator that can check if the picker is in edit mode (has masks etc.) not custom in formality, but just a func that can be run in the context of the component...

	// TODO: could detect 32 for day and move the 2 into the month position
	// TODO: have to handle deleting a bit better (delete the 1 from 19 and it changes to 09, delete the / after 12/ and it stuffs up)
	//			replace the deleted number with a _
	//			put back the deleted / and replace the previous number with the mask char
	// TODO: also handle delete in front
	// TODO: what about select and delete... oh god - i guess: first we have to repair the delete, put the mask back in, put the /'s back in. then we can process normally? kind of the same as what we need to do with paste.
	// 			ooh yeah, find what it was, replace digits with _, put it back - this leaves the /'s

	// TODO: handle pasting (the new value replaces the current value, i.e. any /'s "slide up" over the existing value, also maybe need to split rest incase there are more than 2 /'s)

	const value = `${dd !== undefined ? dd : '__'}/${mm !== undefined ? mm : '__'}/${yyyy !== undefined ? yyyy : '____'}`
	debug('conformedValue, newConformedValue', conformedValue, value)
	// if nothing changed, send the existing conformedValue
	const returnValue = indexesOfPipedChars ? { value, indexesOfPipedChars } : value
	debug('return', hasNewValue ? returnValue : conformedValue)
	return hasNewValue ? returnValue : conformedValue

	// const next = !!this.state.dateInput.lastKeyDown.match(/[-/:. ]/)

	// return conformedValue
}

class DateOfBirthPicker extends React.Component {
	render() {
		debug('DateOfBirthPicker this.props', this.props)
		return (
			<DatePicker
				allowKeyboardControl
				animateYearScrolling={false}
				autoOk
				disableFuture
				disableOpenOnEnter
				format="DD/MM/YYYY"
				initialFocusedDate={moment('1999-07-01')} // middle of the year, some reasonable time ago
				invalidDateMessage={this.context.translate('Please enter your date of birth')}
				keepCharPositions
				keyboard
				keyboardIcon={<CalendarTodayOutlined />}
				label={this.context.translate('Date of Birth (D/M/YY)')}
				leftArrowIcon={<KeyboardArrowLeftOutlined />}
				maxDateMessage={this.context.translate('Date of birth should be in the past')}
				mask={value => (value ? [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/] : [])}
				openToYearSelection={!this.props.value}
				pipe={dateOfBirthPipe}
				placeholder="D/M/YY" // minimal, to suggest that they can enter the date in a short form
				rightArrowIcon={<KeyboardArrowRightOutlined />}
				{...this.props}
			/>
		)
	}
}

DateOfBirthPicker.contextTypes = {
	translate: PropTypes.func
}

DateOfBirthPicker.propTypes = {
	value: PropTypes.any, // eslint-disable-line react/forbid-prop-types
	onChange: PropTypes.func.isRequired
}

DateOfBirthPicker.defaultProps = {
	value: undefined
}

export default DateOfBirthPicker



// WEBPACK FOOTER //
// ./src/components/DateOfBirthPicker.jsx